import { css } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getOnboardingProgressBarStyles = (theme: Theme) =>
    css({
        width: '100%',
        height: 4,
        backgroundColor: theme.palette.gray.light,
        flexShrink: 0,
    });

export const getProgressStyles = (width: number) => (theme: Theme) =>
    css({
        width: `${width}%`,
        height: '100%',
        backgroundColor: theme.palette.primary.main,
        transition: `width 0.3s ease-in-out`,
    });
